import { useFormikContext } from 'formik';
import { useCallback } from 'react';
import { compareDateObjects } from '~/modules/common/dates/compare';
import { ALLOCATION_PERIOD } from '../../AllocationByPeriod';

const PERIOD_HOURS_FIELD_MAP = {
  [ALLOCATION_PERIOD.ENTIRE_PERIOD]: 'hoursForEntirePeriod',
  [ALLOCATION_PERIOD.MONTH]: 'hoursPerMonth',
  [ALLOCATION_PERIOD.WEEK]: 'hoursPerWeek'
};

export const useSetResourceAllocationOnChangeHandlers = () => {
  const { values, setFieldValue, setValues } = useFormikContext();

  const onStartDateChange = useCallback(
    startDate => {
      const isStartDateAfterEndDate =
        compareDateObjects(startDate, values.endDate) === 1;

      setValues({
        ...values,
        startDate,
        endDate: isStartDateAfterEndDate ? startDate : values.endDate
      });
    },
    [setValues, values]
  );

  const onEndDateChange = useCallback(
    endDate => {
      const isEndDateBeforeStartDate =
        compareDateObjects(endDate, values.startDate) === -1;

      setValues({
        ...values,
        startDate: isEndDateBeforeStartDate ? endDate : values.startDate,
        endDate
      });
    },
    [setValues, values]
  );

  const onClearAllocationChange = useCallback(
    ({ target: { checked } }) => {
      setFieldValue('isClearAllocationChecked', checked);
    },
    [setFieldValue]
  );

  const onSelectedAllocationPeriodChange = useCallback(
    (_, selectedTab) => {
      setFieldValue('selectedAllocationPeriod', selectedTab);
    },
    [setFieldValue]
  );

  const onHoursValueChange = useCallback(
    hours => {
      const { selectedAllocationPeriod } = values;
      const fieldName = PERIOD_HOURS_FIELD_MAP[selectedAllocationPeriod];

      setFieldValue(fieldName, hours);
    },
    [setFieldValue, values]
  );

  const onPercentageValueChange = useCallback(
    percentage => {
      setFieldValue('percentageForEntirePeriod', percentage);
    },
    [setFieldValue]
  );

  return {
    onStartDateChange,
    onEndDateChange,
    onClearAllocationChange,
    onSelectedAllocationPeriodChange,
    onHoursValueChange,
    onPercentageValueChange
  };
};
